import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { debounce } from "../../../utils";

gsap.registerPlugin(ScrollTrigger);

class BioFutureBlocks {
    constructor() {
        this.svg = document.getElementById('bh-mask-svg-container')
        this.initGrid()
        this.initScrollTrigger()
        this.width = window.innerWidth;
        this.initEvents()
    }

    initEvents() {
        window.addEventListener('resize', debounce(() => {
            this.onResize();
        }, 200));
    }

    handleResize() {
        // recalculate scroll trigger
        ScrollTrigger.getAll().forEach(instance => {
            instance.kill();
        })
        this.timeline.kill()
        this.initScrollTrigger()
    }

    onResize() {
        this.previousWidth = this.width;
        this.width = window.innerWidth;
        if (this.previousWidth !== this.width) {
            this.handleResize();
        }
    }

    initGrid() {
        const oneThird = 1/3
        gsap.set('#gbp-1-left-v', {transformOrigin: "50% 50%", scaleY: oneThird})
        gsap.set('#gbp-1-left-h', {transformOrigin: "50% 50%", scaleX: oneThird})
        gsap.set('#gbp-1-left', {transformOrigin: "50% 50%", yPercent: "+=10", scale: 0})

        gsap.set('#gbp-1-right-v', {height: 0})
        gsap.set('#gbp-1-right-h', {transformOrigin: "50% 50%", scaleX: 0})

        gsap.set('#gbp-1-center-v', {transformOrigin: "50% 100%", scaleY: 0})
        gsap.set('#gbp-1-center-h', {transformOrigin: "100% 50%", scaleX: 0})

        gsap.set('#gb-rect-1-left', {scaleX: 0})
        gsap.set('#gb-rect-1-right', {scaleY: 0})

        gsap.set('#gbp-2-left-v', {height: 0})
        gsap.set('#gbp-2-left-h', {transformOrigin: "50% 50%", scaleX: 0})

        gsap.set('#gbp-2-center-v', {transformOrigin: "50% 100%", scaleY: 0})
        gsap.set('#gbp-2-center-h', {transformOrigin: "100% 50%", scaleX: 0})

        gsap.set('#gbp-2-right-v', {transformOrigin: "50% 50%", scaleY: oneThird})
        gsap.set('#gbp-2-right-h', {transformOrigin: "50% 50%", scaleX: oneThird})
        gsap.set('#gbp-2-right', {transformOrigin: "50% 50%", yPercent: "+=10", scale: 0})

        gsap.set('#gb-rect-3-left', {transformOrigin: "0 50%", scaleX: 0})
        gsap.set('#gb-rect-3-right', {transformOrigin: "100% 50%", scaleX: 0})
    }

    getScrollPositionForSvgCenter(targetY) {
        const svgHeight = this.svg.getBoundingClientRect().height;
        const originalHeight = 3360;
        const scaleY = svgHeight / originalHeight;
        const adjustedY = targetY * scaleY;
        const windowHeight = window.innerHeight;
        return adjustedY - (windowHeight / 2);
    }

    initScrollTrigger() {
        const oneThird = 1/3

        const stage1 = 1.2;
        const stage2 = 2.6;
        const stage3 = 4;
        const textBlock1 = document.querySelector('.bh-grid-mask--inner .txt-block.block-01');
        const textBlock2 = document.querySelector('.bh-grid-mask--inner .txt-block.block-02');
        const textBlock3 = document.querySelector('.bh-grid-mask--inner .txt-block.block-03');

        this.timeline = gsap.timeline({
            defaults: {
                ease: "none",
                force3D: true,
            },
            scrollTrigger: {
                trigger: '.bh-grid-mask',
                start: "top 50%",
                end: "bottom bottom",
                scrub: 1,
            }
        })
            // .to('.plus-pattern', {yPercent: "-=100", duration: 4}, 0)
            .to('#gbp-1-left', {scale: 1, yPercent: "-=10", transformOrigin: "50% 50%", duration: 1})
            .to('#gbp-1-left-v', {scaleY: 1, transformOrigin: "50% 50%", duration: 0.5}, 0.5)
            .to('#gbp-1-left-h', {scaleX: 1, transformOrigin: "50% 50%", duration: 0.5}, 0.5)

            .to('#gbp-1-right-v', {height: "722", duration: 1}, 0)
            .to('#gbp-1-right-h', {scaleX: 1, transformOrigin: "50% 50%", duration: .4}, .65)

            .to('#gbp-1-center-v', {scaleY: 1, transformOrigin: "50% 100%", duration: 1}, 0.35)
            .to('#gbp-1-center-h', {scaleX: 1, transformOrigin: "100% 50%", duration: 1}, 0.7)

            .to('#gb-rect-1-left', {scaleX: 1, transformOrigin: "0 0", duration: .5}, 1.2)
            .to('#gb-rect-1-right', {scaleY: 1, transformOrigin: "0 0", duration: .5}, 1.2)

            .to(this.svg, {
                y: () => { // -350
                    return -this.getScrollPositionForSvgCenter(1150)
                },
                duration: 1,
            }, stage1)

            .to(textBlock1, {
                opacity: 1,
                duration: 0.3,
            }, stage1 + .9)

            .to('#gbp-2-right', {scale: 1, yPercent: "-=10", transformOrigin: "50% 50%", duration: 1}, 1)
            .to('#gbp-2-right-v', {scaleY: 1, transformOrigin: "50% 50%", duration: 0.5}, 1.5)
            .to('#gbp-2-right-h', {scaleX: 1, transformOrigin: "50% 50%", duration: 0.5}, 1.5)

            .to('#gbp-2-left-v', {height: "722", duration: 1}, 1)
            .to('#gbp-2-left-h', {scaleX: 1, transformOrigin: "50% 50%", duration: .4}, 1.65)

            .to('#gbp-2-center-v', {scaleY: 1, transformOrigin: "50% 100%", duration: 1}, 1.35)
            .to('#gbp-2-center-h', {scaleX: 1, transformOrigin: "100% 50%", duration: 1}, 1.7)

            .to(textBlock1, {
                opacity: 0,
                duration: .5,
                y: "-=400"
            }, stage2)

            .to(this.svg, {
                y: () => { //-1100
                    return -this.getScrollPositionForSvgCenter(2100)
                },
                duration: 1,
            }, stage2)

            .to(textBlock2, {
                opacity: 1,
                duration: 0.3,
            }, stage2 + .9)


            .to('#gbp-1-right-v', {scaleY: oneThird, transformOrigin: "50% 50%", duration: 0.5}, stage2)
            .to('#gbp-1-right-h', {scaleX: oneThird, transformOrigin: "50% 50%", duration: 0.5}, stage2)

            .to('#gbp-1-left-v', {scaleY: 0, transformOrigin: "50% 0", duration: 1}, stage2)
            .to('#gbp-1-left-h', {scaleY: 0, transformOrigin: "50% 0", duration: oneThird}, (stage2 + .1))

            .to('#gb-rect-1-right', {scaleY: 0, transformOrigin: "0 100%", duration: oneThird * 2}, (stage2 + .1))
            .to('#gb-rect-1-left', {scaleY: 0, transformOrigin: "50% 50%", duration: oneThird * 2}, (stage2 + .1))

            .to('#gb-rect-3-left', {scaleX: 1, transformOrigin: "0 50%", duration: 1}, (stage2 + .2))
            .to('#gb-rect-3-right', {scaleX: 1, transformOrigin: "100% 50%", duration: 1}, (stage2 + .2))

            .to(textBlock2, {
                opacity: 0,
                duration: .5,
                y: "-=400"
            }, stage3)

            .to(this.svg, {
                y: () => {
                    // get heigh of svg and minus window height
                    return -this.getScrollPositionForSvgCenter(3120)
                },
                duration: 1,
            }, stage3)

            .to(textBlock3, {
                opacity: 1,
                duration: 0.3,
            }, stage3 + .9)

            .to('#gb-rect-2-right', {scaleY: 0, transformOrigin: "50% 0", duration: oneThird * 2}, (stage3 + 1.2))
    }
}

export default BioFutureBlocks
